import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["component", "restrictedType"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { api } from 'src/api';
import { Navigate } from 'react-router-dom';
import { RESTRICTED_TYPES } from './routes';
import { IS_PAYMENT_METHOD } from 'src/constants/payments';
import { USER_ROLES_BY_NAME, USER_SETTINGS_KEYS } from 'src/constants/userSetting';
export const RestrictedRoute = _ref => {
  let Component = _ref.component,
    restrictedType = _ref.restrictedType,
    rest = _objectWithoutProperties(_ref, _excluded);
  const paygate = JSON.parse(localStorage.getItem(IS_PAYMENT_METHOD));
  const userRole = localStorage.getItem(USER_SETTINGS_KEYS.userRole);
  const isLoggedIn = api.Account.isLoggedIn();
  const isDemoModeOn = api.Account.isDemoModeOn();
  const isDesignMode = localStorage.getItem('livable_design_mode') === 'true';
  const userCompany = localStorage.getItem(USER_SETTINGS_KEYS.company) !== 'null';
  const isConfirmationEmail = !!localStorage.getItem(USER_SETTINGS_KEYS.confirmation);
  const userEmailConfirmed = JSON.parse(localStorage.getItem(USER_SETTINGS_KEYS.emailConfirmed));
  const userPhoneConfirmed = JSON.parse(localStorage.getItem(USER_SETTINGS_KEYS.phoneConfirmed));
  const isUserVerifyEmail = isLoggedIn && userEmailConfirmed;
  const isUserVerifyPhone = isLoggedIn && userPhoneConfirmed;
  if (isConfirmationEmail && restrictedType !== RESTRICTED_TYPES.PROFILE_SAVED && restrictedType !== RESTRICTED_TYPES.CONFIRM_ACCOUNT || isLoggedIn && !isUserVerifyEmail && restrictedType !== RESTRICTED_TYPES.PROFILE_SAVED && restrictedType !== RESTRICTED_TYPES.CONFIRM_ACCOUNT) {
    return /*#__PURE__*/React.createElement(Navigate, {
      to: "/profile_saved"
    });
  } else if (isLoggedIn && !isUserVerifyPhone && !userCompany && restrictedType !== RESTRICTED_TYPES.CONFIRM_ACCOUNT && restrictedType !== RESTRICTED_TYPES.COMPANY_DETAILS && restrictedType !== RESTRICTED_TYPES.PROFILE_SAVED && restrictedType !== RESTRICTED_TYPES.PAYGATE && restrictedType !== RESTRICTED_TYPES.MFA) {
    return /*#__PURE__*/React.createElement(Navigate, {
      to: "/mfa"
    });
  } else if (isLoggedIn && !userCompany && restrictedType !== RESTRICTED_TYPES.CONFIRM_ACCOUNT && restrictedType !== RESTRICTED_TYPES.COMPANY_DETAILS && restrictedType !== RESTRICTED_TYPES.PROFILE_SAVED && restrictedType !== RESTRICTED_TYPES.PAYGATE && restrictedType !== RESTRICTED_TYPES.MFA) {
    return /*#__PURE__*/React.createElement(Navigate, {
      to: "/company_details"
    });
  } else if (isLoggedIn && !isDemoModeOn && !paygate && userRole === USER_ROLES_BY_NAME.PropertyManagerAccountHolder && restrictedType !== RESTRICTED_TYPES.CONFIRM_ACCOUNT && restrictedType !== RESTRICTED_TYPES.COMPANY_DETAILS && restrictedType !== RESTRICTED_TYPES.PROFILE_SAVED && restrictedType !== RESTRICTED_TYPES.MFA && restrictedType !== RESTRICTED_TYPES.PAYGATE) {
    return /*#__PURE__*/React.createElement(Navigate, {
      to: "/paygate"
    });
  }
  let routeAccessCheck;
  switch (restrictedType) {
    case RESTRICTED_TYPES.DESIGN:
      routeAccessCheck = isDesignMode;
      break;
    case RESTRICTED_TYPES.MFA:
      routeAccessCheck = !isLoggedIn || isLoggedIn && !isUserVerifyPhone && !userCompany;
      break;
    case RESTRICTED_TYPES.PROFILE_SAVED:
      routeAccessCheck = isLoggedIn && !isUserVerifyEmail || isConfirmationEmail;
      break;
    case RESTRICTED_TYPES.COMPANY_DETAILS:
      routeAccessCheck = isLoggedIn && (!userCompany || !paygate);
      break;
    case RESTRICTED_TYPES.PAYGATE:
      routeAccessCheck = isLoggedIn && !isDemoModeOn && !paygate;
      break;
    case RESTRICTED_TYPES.CONFIRM_ACCOUNT:
      routeAccessCheck = isLoggedIn && !isUserVerifyEmail || !isLoggedIn;
      break;
    default:
      routeAccessCheck = !isLoggedIn;
      break;
  }
  return routeAccessCheck ? /*#__PURE__*/React.createElement(Component, {
    props: _objectSpread({}, rest)
  }) : /*#__PURE__*/React.createElement(Navigate, {
    to: "/active_dashboard"
  });
};